// 知识库搜索结果片段高亮：在原文上按关键词（字面量、忽略大小写）切分，
// 再逐段做 HTML 转义防 XSS，命中段包一层 <mark>。先切分后转义，关键词不会误命中
// 转义产生的实体（如关键词 amp / lt 命中 &amp; / &lt;）。
// keyword 为空（null/undefined/""）时只返回转义后的 text，不加 <mark>。

function escapeHtml(str) {
  return String(str ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function highlightSnippet(text, keyword) {
  const raw = String(text ?? "");
  if (!keyword) {
    return escapeHtml(raw);
  }
  // 带捕获组的 split：奇数下标是命中的关键词，偶数下标是其间的普通文本
  const re = new RegExp(`(${escapeRegExp(String(keyword))})`, "gi");
  return raw
    .split(re)
    .map((part, i) => (i % 2 === 1 ? `<mark>${escapeHtml(part)}</mark>` : escapeHtml(part)))
    .join("");
}
